import { ApiNewDokumentPowiazanyDalDto, EgibObject } from '@gk/gk-modules';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';

export interface LBRDUUERNewDataUpdateRequestDto
  extends ExtendedApplicantRequestDto {
  ZakresZmiany: string;
  Lokalizacja: string;
}

export class LBRDUUERNewDataUpdateRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    public changeScope: string,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    public determinationOfLocation: string,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      undefined,
      undefined,
    );
  }

  static fromAppToApi(
    data: LBRDUUERNewDataUpdateRequest,
    parcels: EgibObject[],
    buildings: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): LBRDUUERNewDataUpdateRequestDto {
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        parcels,
        buildings,
        files,
      }),
      ZakresZmiany: data.changeScope,
      Lokalizacja: data.determinationOfLocation,
    };
  }
}

export interface LBRDUUERNewDataUpdateRequestFormWorkspaceState
  extends WorkspaceState {
  formValue: LBRDUUERNewDataUpdateRequest;
  parcels: EgibObject[];
  buildings: EgibObject[];
}
